import { Injectable } from '@angular/core';
import {
  ICreateSilobolsa,
  IDispositivo,
  IQueryParam,
  IReporte,
  ISilobolsa,
  IUpdateSilobolsa,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';
import { apiBase } from 'src/environments/environment';
const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class SilobolsasService {
  constructor(private http: HttpService) { }

  public getSilobolsa(id: string): Observable<ISilobolsa> {
    return this.http.get(`${api}/silobolsas/${id}`);
  }
  public getSilobolsas(queryParams?: IQueryParam): Observable<{
    data: ISilobolsa[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/silobolsas`, { params });
  }
  public createSilobolsa(data: ICreateSilobolsa): Observable<ISilobolsa> {
    return this.http.post(`${api}/silobolsas`, data);
  }
  public updateSilobolsa(
    id: string,
    data: IUpdateSilobolsa,
  ): Observable<ISilobolsa> {
    return this.http.put(`${api}/silobolsas/${id}`, data);
  }
  public deleteSilobolsa(id: string): Observable<ISilobolsa> {
    return this.http.delete(`${api}/silobolsas/${id}`);
  }

  public frecReporte(deveui: string, frecuencia: number) {
    return this.http.post(`${api}/comandos/frecReporte`, {
      deveui: deveui,
      frecuencia,
    });
  }

  // Reportes
  // public exportar(queryParams?: IQueryParam): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     let params = HelperService.getQueryParams(queryParams);

  //     this.http
  //       .get(`${api}/reportes/exportar`, { params, responseType: 'blob' })
  //       .subscribe(
  //         (response: any) => {
  //           try {
  //             const file = new File([response], 'registros-nuc.xlsx');
  //             saveAs(file);
  //             resolve();
  //           } catch (error) {
  //             console.error(error);
  //             resolve();
  //           }
  //         },
  //         (error: any) => {
  //           const reader: FileReader = new FileReader();
  //           reader.onloadend = (e) => {
  //             reject(JSON.parse(reader.result as string));
  //           };
  //           reader.readAsText(error.error);
  //         }
  //       );
  //   });
  // }

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(
      `${api}/reportes/exportar/silobolsas`,
      filename,
      params,
    );
  }

  // Helper

  public devolverPromedioLlenado(dispositivos?: IDispositivo[]): number {
    let suma = 0;
    let contador = 0;
    if (dispositivos?.length) {
      for (const dispositivo of dispositivos) {
        const reporte = dispositivo.ultimoReporte;
        if (reporte?.reporte?.tipo !== 'anulada') {
          const fechaNormalizada = this.normalizarFecha(
            new Date().toISOString(),
          );
          if (!reporte?.fecha) return 0;

          const fechaReporte = reporte.fecha;
          const horasTranscurridas = this.horasTranscurridas(
            fechaNormalizada,
            fechaReporte,
          );
          if (horasTranscurridas < 3) {
            suma += reporte?.reporte?.porcentaje || 0;
            contador++;
          }
        }
      }
    }
    if (contador) {
      return suma / contador;
    }
    return 0;
  }

  public devolverPromedioLlenadoReportes(reportes?: IReporte[]): number {
    let suma = 0;
    let contador = 0;
    if (reportes?.length) {
      for (const reporte of reportes) {
        if (
          reporte?.reporte?.tipo !== 'anulada' &&
          reporte?.reporte?.tipo !== 'obstruido'
        ) {
          // const fechaNormalizada = this.normalizarFecha(
          //   new Date().toISOString(),
          // );
          // const fechaReporte = reporte?.fecha!;
          // const horasTranscurridas = this.horasTranscurridas(
          //   fechaNormalizada,
          //   fechaReporte,
          // );
          // if (horasTranscurridas < 3) {
          suma += reporte?.reporte?.porcentaje || 0;
          contador++;
          // }
        }
      }
    }
    if (contador) {
      return suma / contador;
    }
    return 0;
  }

  public devolverPorcentajeLlenado(
    dispositivo?: IDispositivo,
    reporte?: IReporte,
  ): number {
    const porcentaje = reporte?.reporte?.porcentaje;
    if (porcentaje || porcentaje === 0) {
      return porcentaje;
    }
    return dispositivo?.ultimoReporte?.reporte?.porcentaje || 0;
  }

  public devolverPorcentajeLlenadoReporte(reporte?: IReporte): number {
    return reporte?.reporte?.porcentaje || 0;
  }

  /**
   * Devuelve false si no hay distancia, si la fecha tiene mas de 1 hora o si la distancia es menor a la distancia minima configurada / 1.1
   */
  public devolverDistancia(
    dispositivo?: IDispositivo,
    reporte?: IReporte,
  ): number | false {
    const distancia = reporte?.reporte?.distancia;
    if (distancia || distancia === 0) {
      return distancia;
    }
    return dispositivo?.ultimoReporte?.reporte?.distancia;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  public estadoDispositivo(dato: IDispositivo) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.fechaUltimaComunicacion
      ? new Date(dato.fechaUltimaComunicacion)
      : null;
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return 'Alerta';
      }
    }
    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }
    return 'Ok';
  }

  static estadoDispositivo2(dato: IDispositivo) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - 6);
    const limite = fecha;
    const ultimaComunicacion = dato.fechaUltimaComunicacion
      ? new Date(dato.fechaUltimaComunicacion)
      : null;
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return 'Alerta';
      }
    }
    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }
    return 'Ok';
  }

  //

  public offsetHoras(fecha: string, offset: number): string {
    const fechaNormalizada = new Date(fecha);
    fechaNormalizada.setHours(fechaNormalizada.getHours() + offset);
    return fechaNormalizada.toISOString();
  }

  public normalizarFecha(fecha: string): string {
    const fechaNormalizada = new Date(fecha);
    fechaNormalizada.setHours(fechaNormalizada.getHours());
    fechaNormalizada.setMinutes(0, 0, 0);
    return fechaNormalizada.toISOString();
  }

  public normalizarFechaXMinutos(fecha: string, x: number): string {
    const fechaNormalizada = new Date(fecha);
    const minutos = fechaNormalizada.getMinutes();
    if (x) {
      fechaNormalizada.setMinutes(minutos - (minutos % x) + x, 0, 0);
      return fechaNormalizada.toISOString();
    } else {
      fechaNormalizada.setSeconds(0, 0);
      return fechaNormalizada.toISOString();
    }
  }

  public horasTranscurridas(fecha1: string, fecha2: string) {
    const date1 = new Date(fecha1).getTime();
    const date2 = new Date(fecha2).getTime();
    const dif = Math.abs(date2 - date1);
    return Math.trunc(dif / 1000 / 60 / 60);
  }

  public fechaEnXDiasALas00(dias: number): Date {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() + dias);
    fecha.setHours(0, 0, 0, 0);
    return fecha;
  }

  public fechaHaceXHorasALas00(horas: number): Date {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    fecha.setMinutes(0, 0, 0);
    return fecha;
  }

  public promedio(silobolsa: ISilobolsa, tipo: 'T' | 'B' | 'H' | 'HE' | 'CO2') {
    const dispos = silobolsa.dispositivosCo2!;

    if (tipo === 'T') {
      const temps = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.temperaturaGrados) {
          temps.push(+d.ultimoReporte?.reporte?.temperaturaGrados);
        }
      }
      const promedio =
        temps.reduce((acc, curr) => acc + curr, 0) / temps.length;
      return promedio;
    }
    if (tipo === 'B') {
      const bats = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.bateriaPorc) {
          bats.push(+d.ultimoReporte?.reporte?.bateriaPorc);
        }
      }
      if (bats.length) {
        const promedio =
          bats.reduce((acc, curr) => acc + curr, 0) / bats.length;
        return promedio;
      }
    }
    if (tipo === 'H') {
      const hums = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.humedadPorc) {
          hums.push(+d.ultimoReporte?.reporte?.humedadPorc);
        }
      }
      const promedio = hums.reduce((acc, curr) => acc + curr, 0) / hums.length;
      return promedio;
    }
    if (tipo === 'HE') {
      const humsEq = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.humedadEquilibrio) {
          humsEq.push(+d.ultimoReporte?.reporte?.humedadEquilibrio);
        }
      }
      const promedio =
        humsEq.reduce((acc, curr) => acc + curr, 0) / humsEq.length;
      return promedio;
    }
    if (tipo === 'CO2') {
      const co2s = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.co2Porc) {
          co2s.push(+d.ultimoReporte?.reporte?.co2Porc);
        }
      }
      const promedio = co2s.reduce((acc, curr) => acc + curr, 0) / co2s.length;
      return promedio;
    }
    return 'Sin Reportar';
  }

  static promedio(silobolsa: ISilobolsa, tipo: 'T' | 'B' | 'H' | 'CO2' | 'HE') {
    const dispos = silobolsa.dispositivosCo2!;

    if (tipo === 'T') {
      const temps = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.temperaturaGrados) {
          temps.push(+d.ultimoReporte?.reporte?.temperaturaGrados);
        }
      }
      const promedio =
        temps.reduce((acc, curr) => acc + curr, 0) / temps.length;
      return promedio;
    }
    if (tipo === 'B') {
      const bats = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.bateriaPorc) {
          bats.push(+d.ultimoReporte?.reporte?.bateriaPorc);
        }
      }
      if (bats.length) {
        const promedio =
          bats.reduce((acc, curr) => acc + curr, 0) / bats.length;
        return promedio;
      }
    }
    if (tipo === 'H') {
      const hums = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.humedadPorc) {
          hums.push(+d.ultimoReporte?.reporte?.humedadPorc);
        }
      }
      const promedio = hums.reduce((acc, curr) => acc + curr, 0) / hums.length;
      return promedio;
    }
    if (tipo === 'CO2') {
      const co2s = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.co2Porc) {
          co2s.push(+d.ultimoReporte?.reporte?.co2Porc);
        }
      }
      const promedio = co2s.reduce((acc, curr) => acc + curr, 0) / co2s.length;
      return promedio;
    }
    if (tipo === 'HE') {
      const hes = [];
      for (const d of dispos) {
        if (d.ultimoReporte?.reporte?.humedadEquilibrio) {
          hes.push(+d.ultimoReporte?.reporte?.humedadEquilibrio);
        }
      }
      const promedio = hes.reduce((acc, curr) => acc + curr, 0) / hes.length;
      return promedio;
    }
    // return 'Sin Reportar';
    return;
  }

  static parseDispositivos(dispositivos?: IDispositivo[]) {
    if (dispositivos) {
      const dispositivosParseados: string[] = [];
      for (const d of dispositivos) {
        dispositivosParseados.push(`
        <p
        style="margin: 0"
      >
        ${d.config?.nombre || d.deviceName}
      </p>
        `);
      }
      return dispositivosParseados.join('');
    } else {
      return '';
    }
  }

  static parseEstado(disp: IDispositivo) {
    const estado = this.estadoDispositivo2(disp);
    if (estado === 'Ok') {
      return `<span class="material-icons" style="color: green">check_circle</span>`;
    } else {
      return `<span class="material-icons" style="color: red">error</span>`;
    }
  }
}
